'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getMapFromList;
function getMapFromList(list) {
    var attrName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';

    var map = {};
    list && list.forEach(function (x) {
        map[x[attrName]] = x;
    });
    return map;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvdXRpbHMvZ2V0TWFwRnJvbUxpc3QuanN4Il0sIm5hbWVzIjpbImdldE1hcEZyb21MaXN0IiwibGlzdCIsImF0dHJOYW1lIiwibWFwIiwiZm9yRWFjaCIsIngiXSwibWFwcGluZ3MiOiI7Ozs7O2tCQUF3QkEsYztBQUFULFNBQVNBLGNBQVQsQ0FBd0JDLElBQXhCLEVBQStDO0FBQUEsUUFBakJDLFFBQWlCLHVFQUFOLElBQU07O0FBQzFELFFBQU1DLE1BQU0sRUFBWjtBQUNBRixZQUFRQSxLQUFLRyxPQUFMLENBQWEsYUFBSztBQUFDRCxZQUFJRSxFQUFFSCxRQUFGLENBQUosSUFBbUJHLENBQW5CO0FBQXFCLEtBQXhDLENBQVI7QUFDQSxXQUFPRixHQUFQO0FBQ0giLCJmaWxlIjoiZ2V0TWFwRnJvbUxpc3QuanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBnZXRNYXBGcm9tTGlzdChsaXN0LCBhdHRyTmFtZSA9ICdpZCcpIHtcbiAgICBjb25zdCBtYXAgPSB7fTtcbiAgICBsaXN0ICYmIGxpc3QuZm9yRWFjaCh4ID0+IHttYXBbeFthdHRyTmFtZV1dID0geH0pO1xuICAgIHJldHVybiBtYXBcbn1cbiJdfQ==